import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // If we are not making a request to our own API, then dont add our JWT token header
    if (!httpRequest.url.includes(window['ApiUrl'])) {
      return next.handle(httpRequest);
    }

    const JWTToken = localStorage.getItem("token");
    return next.handle(httpRequest.clone({ setHeaders: { Authorization: 'Bearer ' + JWTToken } }));
  }
}
